var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnwserIconSafe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 63.86 77.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        fill: #f9de00;\n      }\n\n      .cls-4 {\n        fill: #2d8e37;\n      }\n\n      .cls-5 {\n        fill: #184a22;\n      }\n\n      .cls-6 {\n        fill: #161615;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.91.44C20.15,1.56,10.67,4.49,1.98,9.06.8,9.66.04,10.86,0,12.18v34.31c0,1.4.29,2.78.87,4.04,2.26,4.91,5.38,9.37,9.22,13.18,4.4,4.32,9.61,7.71,15.34,9.98,2.75,1.52,5.64,2.78,8.63,3.75.95.28,1.98.13,2.82-.41,7.1-4.43,13.31-10.14,18.31-16.84,3.18-4.27,5.81-8.93,7.82-13.85.55-1.33.84-2.75.85-4.19V7.8c.02-1.23-.8-2.32-1.99-2.65l-4.61-2.19c-.26-.18-.55-.32-.85-.4C50.37.85,44.12,0,37.84,0c-2.65,0-5.29.15-7.92.44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.55,11.01c-7.52.86-14.82,3.11-21.53,6.64-.91.46-1.49,1.38-1.52,2.4v26.44c0,1.08.22,2.14.67,3.12,1.74,3.78,4.14,7.22,7.1,10.15,4.02,3.93,8.91,6.87,14.27,8.58.73.22,1.53.1,2.17-.32,5.47-3.41,10.25-7.81,14.11-12.98,2.45-3.29,4.47-6.88,6.02-10.67.42-1.02.65-2.12.65-3.23V14.68c.02-.95-.61-1.79-1.53-2.04-4.66-1.31-9.47-1.97-14.31-1.96-2.04,0-4.08.11-6.11.34"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5985",
    "data-name": "Groupe 5985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5976",
    "data-name": "Groupe 5976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5975",
    "data-name": "Groupe 5975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26705",
    "data-name": "Trac\\xE9 26705",
    className: "cls-4",
    d: "M61.88,5.15l-4.61-2.19c-.26-.18-.55-.32-.85-.4C47.8.15,38.8-.57,29.92.45,20.15,1.57,10.68,4.49,1.98,9.07.8,9.67.04,10.86,0,12.18v34.3c0,1.4.29,2.78.87,4.05,2.26,4.91,5.38,9.37,9.22,13.18,4.4,4.32,9.61,7.71,15.34,9.98,2.75,1.52,5.64,2.78,8.63,3.75.95.28,1.98.13,2.82-.41,7.1-4.43,13.31-10.14,18.31-16.85,3.18-4.27,5.8-8.93,7.82-13.85.55-1.33.84-2.75.85-4.19V7.8c.02-1.23-.8-2.32-1.99-2.65"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5978",
    "data-name": "Groupe 5978"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5977",
    "data-name": "Groupe 5977"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26706",
    "data-name": "Trac\\xE9 26706",
    className: "cls-5",
    d: "M68.51,7.18c-15.07-3.41-30.71-3.41-45.78,0-4.53,1.05-8.98,2.41-13.31,4.08-1.74.66-2.99,2.19-3.31,4.03-1.37,7.94-1.93,16-1.69,24.06.14,4.72.27,9.13,1.24,12.87,4.3,16.7,26.42,24.89,34.4,27.47l-55.43-6.24L-15.87,0l55.68-15.34,28.7,22.52"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5980",
    "data-name": "Groupe 5980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5979",
    "data-name": "Groupe 5979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26708",
    "data-name": "Trac\\xE9 26708",
    className: "cls-7",
    d: "M12.51,20.06c.03-1.02.61-1.94,1.52-2.4,6.7-3.53,14-5.78,21.53-6.64,6.85-.78,13.78-.23,20.42,1.62.92.25,1.55,1.09,1.53,2.04v26.46c0,1.11-.23,2.21-.65,3.23-1.55,3.8-3.58,7.38-6.03,10.67-3.86,5.17-8.64,9.57-14.11,12.98-.64.42-1.44.53-2.17.32-5.36-1.71-10.25-4.65-14.27-8.58-2.96-2.93-5.36-6.37-7.1-10.15-.45-.98-.68-2.04-.67-3.12v-26.43Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5982",
    "data-name": "Groupe 5982"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5981",
    "data-name": "Groupe 5981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26709",
    "data-name": "Trac\\xE9 26709",
    className: "cls-3",
    d: "M53.58,7.74c.13,11,.25,22.01.38,33.01-.01.68-.16,1.36-.44,1.99-1.29,4.7-3.95,8.04-6.99,11.24-5.33,5.43-11.13,10.38-17.33,14.78l9.92,3.32,26.54-23.84-6.1-40.94-5.97.45"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5984",
    "data-name": "Groupe 5984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5983",
    "data-name": "Groupe 5983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26711",
    "data-name": "Trac\\xE9 26711",
    className: "cls-6",
    d: "M44.02,22.84l4.51,3.07-16.95,24.14-10.08-7.44,3.62-4.49,5.58,4.38,13.33-19.66Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnwserIconSafe);
export default __webpack_public_path__ + "static/media/anwser_icon_safe.f326cabfe68dca168ad92e4e1291dab0.svg";
export { ForwardRef as ReactComponent };